import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateDirective } from '../../../../../components/Utilites/Directives/translate.directive';

@Component({
  selector: 'app-staffassignmentname',
  imports: [
    CommonModule,
    MatCardModule,
    MatListModule,
    MatProgressBarModule,
    MatButtonModule,
    TranslateDirective
  ],
  templateUrl: './staffassignmentname.component.html',
  styleUrls: ['./staffassignmentname.component.scss'],
})
export class ListstaffassignmentnameComponent {
  classId: string | null = null;
  userId: string | null = null;

  assignmentId: string | null = null;
  assignment = {
    id: 1,
    title: 'MPC - A (E.M) | Maths',
    academicYear: '2025 - 2026',
    classDetails: 'MPC - A (E.M) | Maths',
    status: 'pending',
    deadline: '31 May 2025',
    submissions: {
      submitted: 18,
      total: 45,
    },
    reviewStatus: 'Pending',
    questions: [
      'Create a detailed project report about pen and pencil.',
      'Calculate the distance between moon and son.',
      'How many day in 1947 Feb month?',
      'Create a detailed project report about pen and pencil.',
      'Calculate the distance between moon and son.',
      'How many day in 1947 Feb month?',
      'Create a detailed project report about pen and pencil.',
      'Calculate the distance between moon and son.',
      'How many day in 1947 Feb month?',
    ],
  };
  assignmentDetails = [
    {
      icon: 'fa-solid fa-calendar',
      label: 'Academic Year',
      value: this.assignment.academicYear,
      type: 'text' as const,
    },
    {
      icon: 'fa-solid fa-book-open-reader',
      label: 'Class Details',
      value: this.assignment.classDetails,
      type: 'text' as const,
    },
    {
      icon: 'fa-solid fa-circle',
      label: 'Status',
      status: this.assignment.status, // separate field
      type: 'status' as const,
    },
    {
      icon: 'fa-solid fa-clock',
      label: 'Deadline',
      value: this.assignment.deadline,
      type: 'text' as const,
    },
    {
      icon: 'fa-solid fa-file',
      label: 'Submissions',
      submissions: this.assignment.submissions, // separate field
      type: 'progress' as const,
    },
    {
      icon: 'fa-solid fa-eye',
      label: 'Review Status',
      value: this.assignment.reviewStatus,
      type: 'text' as const,
    },
  ];

  constructor(private _router: Router, private router: ActivatedRoute) {}

  getStatusClass(status: string): string {
    switch (status.toLowerCase()) {
      case 'ongoing':
        return 'status-ongoing';
      case 'completed':
        return 'status-completed';
      case 'pending':
        return 'status-pending';
      default:
        return 'status-default';
    }
  }

  getStatusIcon(status: string): string {
    switch (status.toLowerCase()) {
      case 'ongoing':
        return 'fa-solid fa-spinner';
      case 'completed':
        return 'fa-solid fa-circle-check';
      case 'pending':
        return 'fa-solid fa-clock';
      default:
        return 'fa-solid fa-circle-question';
    }
  }

  ngOnInit() {
    this.classId = this.router.snapshot?.paramMap.get('classId');
    this.userId = this.router.snapshot?.paramMap.get('staffId');
    this.assignmentId = this.router.snapshot?.paramMap.get('assignmentId');
  }
  goBack() {
    this._router.navigate([
      `/assignments/staff/${this.userId}/${this.classId}`,
    ]);
  }
  viewSubmissionPage() {
    this._router.navigate([
      `/assignments/staff/${this.userId}/${this.classId}/${this.assignmentId}/submissionspage`,
    ]);
  }
}
